import { useContext } from 'react'
import { ModalContext } from '../ModalContext'

export default function ExerciseAssessmentInfoModal() {

    const { modalData } = useContext(ModalContext)

    // console.log(modalData)

    return (
        <div className='space-y-4'> 

            <div className="text-center text-lg font-semibold text-gray-900">
                {modalData.exerciseName}
            </div>

            {/* Completion Data */}
            {modalData.currentSet && 
                <div className='bg-gray-100 p-4 rounded-lg space-y-2'>

                    {modalData.currentSet.completedSetData.summaryTag === "weak" && <div className="font-bold text-red-600">WEAK ({Math.round(modalData.currentSet.completedSetData.percentageScore)}%)</div>}
                    {modalData.currentSet.completedSetData.summaryTag === "strong" && <div className="font-bold text-green-600">STRONG ({Math.round(modalData.currentSet.completedSetData.percentageScore)}%)</div>}

                    {modalData.exerciseLateral === 'bilateral' &&
                        <div className='border border-gray-400 rounded-lg text-sm'>
                            <div className='p-2'>{modalData.currentSet.completedSetData.setUnitsCompleted} / {modalData.currentSet.reps} reps</div>
                        </div>
                    }

                    {modalData.exerciseLateral === 'unilateral' &&
                        <div className='grid grid-cols-2 gap-2 border border-gray-400 rounded-lg divide-x divide-gray-400 text-sm'>
                            <div className='p-2'>Left Side: {modalData.currentSet.completedSetData.setUnitsCompleted.leftSide} / {modalData.currentSet.reps}</div>
                            <div className='p-2'>Right Side: {modalData.currentSet.completedSetData.setUnitsCompleted.rightSide} / {modalData.currentSet.reps}</div>
                        </div>
                    }

                </div>
            }
           
            {/* Why this exercise is important */}
            <div className="space-y-1 bg-gray-100 p-4 rounded-lg text-left">

                <p className='text-sm font-semibold text-gray-800'>Why is this exercise important?</p>

                <p className="text-xs text-gray-600">{modalData.exerciseInfo.importance}</p>

            </div>
            
            {/* Weakness Impact */}
            <div className="space-y-1 bg-gray-100 p-4 rounded-lg text-left">

                <p className='text-sm font-semibold text-gray-800'>Why should I be strong in this exercise?</p>

                <p className="text-xs text-gray-600">{modalData.exerciseInfo.weakness_impact}</p>

            </div>

            {/* Build-Up Exercises */}
            <div className="space-y-4 bg-gray-100 p-4 rounded-lg text-left">

                <p className='text-sm font-semibold text-gray-800'>What can I do to get stronger?</p>
                
                {modalData.exerciseInfo.build_up_exercises.map((exercise, index) => (
                    <div 
                        key={index} 
                        className="border border-gray-400 rounded-lg p-2 bg-gray-50"
                    >

                        <div className="text-sm">{exercise.name}</div>

                        <p className="text-xs text-gray-600">{exercise.reason}</p>

                        {/* <p className="text-sm text-gray-600 text-start"><strong>How to:</strong> {exercise.how_to}</p> */}

                    </div>
                ))}

            </div>

        </div>
            
    )
}